export default __webpack_public_path__ + "static/media/icon-postulant.fad59a4e.svg";